import { DEBIT_NOTE_HISTORY_URL, DEBIT_NOTE_URL, PURCHASE_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const headersdata = {
  "content-type": "application/json",
  Accept: "application/json",
  get Authorization() {
    const cook = new Cookies().get("loginData1");
    return cook !== undefined ? cook.accessToken : "";
  }
};

const callPostAxios = (URL, data, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(URL, data, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

const callGetAxios = (URL, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(URL, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

const callPutAxios = (URL, data, errorIn) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .put(URL, data, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in ${errorIn} axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDebitNote2 = (billNo) => {
  return callGetAxios(DEBIT_NOTE_URL() + "bill/" + billNo, 'getDebitNote2');
};

export const addDebitNote = (data) => {
  return callPostAxios(DEBIT_NOTE_URL(), data, 'addDebitNote');
};

export const editDebitNote = (id, data) => {
  return callPutAxios(DEBIT_NOTE_URL() + id, data, 'getDebitNoteDetail');
};

export const getDebitNoteDetail = (id) => {
  return callGetAxios(DEBIT_NOTE_URL() + id, 'getDebitNoteDetail');
};

export const getDebitNoteByVendor = (id) => {
  return callGetAxios(DEBIT_NOTE_URL() + "vendor/" + id, 'getDebitNoteByVendor');
};

export const getDebitNoteList = (data) => {
  return callPostAxios(DEBIT_NOTE_URL() + "getAllRecords", data, 'getAllRecords');
};

export const deleteDebitNote = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .delete(DEBIT_NOTE_URL() + id, {
          headers: headersdata,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(`Error in deleteDebitNote axios!`);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getApprovedDebitNotes = (data) => {
  return callPostAxios(DEBIT_NOTE_URL() + "approvedDebitNote", data, 'getApprovedDebitNotes');
};

export const getDebitNotesHistory = (debitNoteNo) => {
  const url = DEBIT_NOTE_HISTORY_URL() + `getDebitNoteHistory/${debitNoteNo}`;
  return callGetAxios(url, 'getDebitNotesHistory');
};
